import { render, staticRenderFns } from "./ButtonLabel.vue?vue&type=template&id=46779703&scoped=true"
import script from "./ButtonLabel.vue?vue&type=script&lang=js"
export * from "./ButtonLabel.vue?vue&type=script&lang=js"
import style0 from "./ButtonLabel.vue?vue&type=style&index=0&id=46779703&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46779703",
  null
  
)

export default component.exports